import {tsdocCommentType} from './comment'
import {tsdocExampleBlockType} from './exampleBlock'
import {tsdocModifierTagType} from './modifierTag'
import {tsdocParamBlockType} from './paramBlock'
import {tsdocRemarksBlockType} from './remarks'
import {tsdocReturnsBlockType} from './returnsBlock'
import {tsdocSeeBlockType} from './seeBlock'

export const tsdocTypes = [
  tsdocCommentType,
  tsdocExampleBlockType,
  tsdocModifierTagType,
  tsdocParamBlockType,
  tsdocRemarksBlockType,
  tsdocReturnsBlockType,
  tsdocSeeBlockType,
]
